import React from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from '../../../helpers'

type Props = {
  title: string
}

const MenuItem: React.FC<Props> = ({
  title
}) => {

  return (
    <div className='menu-item me-lg-1'>
        <span className='menu-title menu-link py-3'>{title}</span>
    </div>
  )
}

export {MenuItem}
